import { FC } from "react"

import { useTranslation } from "react-i18next"

import { i18n } from "$/i18n"
import { isNullOrUndefined } from "$/utils/gates"

import { type TProductTypeQuery, useProductTypeQuery } from "@/3514/queries"
import { buildCssClassName } from "@/3514/utils"
import { CARE_TEAM_EMAIL } from "@/constants"

interface IProps {
    className?: string
    text?: string
    linkClassName?: string
    variant?: "default" | "brand"
}

const CareTeamLink: FC<IProps> = ({
    className,
    linkClassName = String(),
    text = i18n.t("Questions?"),
    variant = "default"
}) => {
    const { t } = useTranslation()
    const { data: productType }: TProductTypeQuery = useProductTypeQuery()

    const productTypeData = isNullOrUndefined(productType)
        ? {
              supportEmail: CARE_TEAM_EMAIL.split(":")[1],
              supportTeamName: "Wiser Care"
          }
        : productType

    return (
        <div
            className={buildCssClassName("color-gray font-italic mt-[50px]", {
                [className]: className,
                "care-team-brank-link": variant === "brand"
            })}
        >
            <span>{text} </span>
            <a
                href={`mailto:${productTypeData?.supportEmail}`}
                className={buildCssClassName("text-underline color-inherit", { [linkClassName]: linkClassName })}
            >
                {t("Contact")} {productTypeData?.supportTeamName}
            </a>
        </div>
    )
}

export default CareTeamLink
